import axiosInstance from './axiosInstance'; 

const API_URL = "https://idealonline.com.tr/service/idealonline/v1/";

export const updatpublisherstemplatesandattributedata = async (id,status,data, token) => {
    const response = await axiosInstance.post(`publisherstemplatesandattributedata/update/${id}/${status}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

export const updatpublisherstemplatesandattributedatafullDelete = async (id, token) => {
    const response = await axiosInstance.get(`publisherstemplatesandattributedata/fullDelete/${id}`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };
    
  export const creatpublisherstemplatesandattributedata = async (id,data, token) => {
    const response = await axiosInstance.post(`publisherstemplatesandattributedata/create/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };
    
  export const updateStatuspublisherstemplatesandattributedata = async (id,status, token) => {
    const response = await axiosInstance.get(`publisherstemplatesandattributedata/updateStatus/${id}/${status}`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };
    
  export const getpublisherstemplatesandattributedata = async (id,status, token) => {
    const response = await axiosInstance.get(`publisherstemplatesandattributedata/search/ListByPublisherId/${id}/${status}`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

    export const getpublisherstemplatesandattributedatasearch = async (id,status, token) => {
    const response = await axiosInstance.get(`publisherstemplatesandattributedata/search/ListByPublisherId/${id}/${status}`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };
    
    
  export const publishersElasticJSONFullList = async (token) => {
    const response = await axiosInstance.get(`publisherstemplatesandattributedata/publishersElasticJSONFullList`,  {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  };

  export const ListByPublisherIdAndTemplateId = async (publisherid,templateid,status, token) => {
    try {
      const response = await axiosInstance.get(`publisherstemplatesandattributedata/ListByPublisherIdAndTemplateId/${publisherid}/${templateid}/${status}`, {
        //params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching authors list:", error);
      throw error;
    }
  };
  

    export const templatesandattributedataListPublisher = async (id,status, token) => {
    try {
      const response = await axiosInstance.get(`publishers/templatesandattributedataList/${id}/${status}`, {
        //params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`,
      }
      
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching publishers list:", error);
      throw error;
    }
  };

    export const templatesandattributedataListPublisherFront = async (id,status, token) => {
    try {
      const response = await axiosInstance.get(`publishers/front/templatesandattributedataList/${id}/${status}`, {
        //params: { page, size },
        headers: {
          Authorization: `Bearer ${token}`,
      }
      
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching publishers list:", error);
      throw error;
    }
  };
